import request from '@/sheep/request';

// 获取专题关键词
export const getSubjectKeywords = async (subjectId: string | number) => {
	return request({
		url: `/wish/subject/keywords/${subjectId}`,
		method: 'GET',
	});
}
